var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _g2, _path10, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInitialAiGeneratedImages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 76,
    viewBox: "0 0 206 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.9537 19.1207C48.7096 14.935 44.7642 11.8742 40.0794 11.8742C39.438 11.8742 38.8131 11.9399 38.2047 12.0493C38.3765 11.3596 38.4774 10.6445 38.4774 9.90549C38.4774 4.71109 33.9701 0.5 28.4092 0.5C23.1803 0.5 18.8842 4.22524 18.3903 8.9906C13.1443 9.82679 9.18884 13.5411 9.18884 17.9992C9.18884 18.0259 9.19385 18.0519 9.19385 18.0786H11.8144C13.8966 18.0786 15.6173 19.5737 15.8714 21.5H48.0482C49.346 21.5 50.3087 20.3141 49.9537 19.1207Z",
    fill: "#EEF0F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.282 34.7077C196.77 34.7077 196.272 34.7608 195.786 34.8495C195.923 34.2911 196.004 33.7122 196.004 33.114C196.004 28.909 192.409 25.5 187.973 25.5C183.803 25.5 180.376 28.5157 179.982 32.3733C175.798 33.0503 172.643 36.0571 172.643 39.666C172.643 39.6876 172.647 39.7087 172.647 39.7303C172.647 39.7303 172.444 40.9406 172.647 42.5H203.638C204.673 42.5 205.441 41.54 205.158 40.5739C204.165 37.1855 201.018 34.7077 197.282 34.7077Z",
    fill: "#EEF0F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.3531 69.5412C68.9534 69.5412 68.5641 69.5818 68.1849 69.6496C68.292 69.2226 68.3549 68.7799 68.3549 68.3224C68.3549 65.1069 65.5462 62.5 62.0809 62.5C58.8227 62.5 56.1456 64.8061 55.8378 67.7561C52.5688 68.2737 50.104 70.5731 50.104 73.3328C50.104 73.3494 50.1072 73.3655 50.1072 73.382C50.1072 73.382 49.9488 74.3076 50.1072 75.5H74.3188C75.1275 75.5 75.7274 74.7659 75.5061 74.0271C74.7309 71.4359 72.2724 69.5412 69.3531 69.5412Z",
    fill: "#EEF0F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6358 20.5H2.6572C1.1921 20.5 0 21.6676 0 23.1033V24.8967C0 26.3324 1.1921 27.5 2.6572 27.5H11.6358C13.1016 27.5 14.2937 26.3324 14.2937 24.8967V23.1033C14.2937 21.6676 13.1016 20.5 11.6358 20.5Z",
    fill: "#EEF0F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.101 54.1148C126.101 53.1246 126.904 52.3219 127.894 52.3219H138.037C139.027 52.3219 139.83 53.1246 139.83 54.1148C139.83 55.105 139.027 55.9077 138.037 55.9077H127.894C126.904 55.9077 126.101 55.105 126.101 54.1148Z",
    fill: "#84BBF9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_301_28911)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57 13.5C57 10.1863 59.6863 7.5 63 7.5H142.524C145.838 7.5 148.524 10.1863 148.524 13.5V63.1301C148.524 66.4438 145.838 69.1301 142.524 69.1301H63C59.6863 69.1301 57 66.4438 57 63.1301V13.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 13.5C58 10.7386 60.2386 8.5 63 8.5H142.524C145.286 8.5 147.524 10.7386 147.524 13.5V63.1301C147.524 65.8915 145.286 68.1301 142.524 68.1301H63C60.2386 68.1301 58 65.8915 58 63.1301V13.5Z",
    stroke: "#667686",
    strokeWidth: 2
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.0084 21.3438C65.0084 18.0301 67.6947 15.3438 71.0084 15.3438H133.372C136.686 15.3438 139.372 18.0301 139.372 21.3438V55.2863C139.372 58.6 136.686 61.2863 133.372 61.2863H71.0084C67.6947 61.2863 65.0084 58.6 65.0084 55.2863V21.3438Z",
    fill: "#FFCB0A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.0084 19.3438C65.0084 17.1347 66.7993 15.3438 69.0084 15.3438H135.372C137.581 15.3438 139.372 17.1347 139.372 19.3438V57.2863C139.372 59.4954 137.581 61.2863 135.372 61.2863H69.0084C66.7993 61.2863 65.0084 59.4954 65.0084 57.2863V19.3438Z",
    fill: "#EEF0F2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.3217 27.6699C91.3217 31.3821 88.2487 34.3931 84.4574 34.3931C80.666 34.3931 77.593 31.3821 77.593 27.6699C77.593 23.9576 80.666 20.9466 84.4574 20.9466C88.2487 20.9466 91.3217 23.9576 91.3217 27.6699Z",
    fill: "#F6CB0F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_301_28911",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 95,
    y: 26,
    width: 45,
    height: 36
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.283 57.8034C139.283 59.5821 137.905 61.0594 136.142 61.2623H95.8393V26.5548L139.283 26.5548V57.8034Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_301_28911)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.365 27.8431L95.8393 46.024L111.89 61.2623H154.788L120.732 27.8431C118.981 26.1253 116.117 26.1253 114.365 27.8431Z",
    fill: "#4D86EC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_301_28911",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 65,
    y: 40,
    width: 43,
    height: 22
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.0094 61.2618C66.768 61.0568 65.0164 59.5805 65.0164 57.8035V40.0588L107.641 40.0588V61.2618H69.0094Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_301_28911)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.6422 41.1962L59.2884 61.2618H78.2283H107.641L92.6903 47.0701L86.5192 41.2107C84.9073 39.6801 82.2622 39.6745 80.6422 41.1962Z",
    fill: "#4D86EC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_301_28911",
    x: 54,
    y: 6.5,
    width: 97.5244,
    height: 67.6301,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.592157 0 0 0 0 0.592157 0 0 0 0 0.592157 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_301_28911"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_301_28911",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInitialAiGeneratedImages);
export default __webpack_public_path__ + "static/media/initialAIGeneratedImages.35d41fba8ca32501159fb14b82693c34.svg";
export { ForwardRef as ReactComponent };